<template>
    <div class="language">
        <input class="language-flag" type="image" v-bind:class="{ unselect: this.$parent.quizData.language != 'fr' }" v-on:click="selectLanguage('fr')" v-bind:src="'images/flag-fr.png'">
        <input class="language-flag" type="image" v-bind:class="{ unselect: this.$parent.quizData.language != 'en' }" v-on:click="selectLanguage('en')" v-bind:src="'images/flag-en.png'">
    </div>
</template>

<script>
export default {
  name: 'LanguageSelector',
  props: ["questionModel"],
  methods: {
        selectLanguage: function (language) {
            this.$emit('language-change', language);      
        }
    }
}
</script>
